import { render, staticRenderFns } from "./SynchronizedPictureDiv.vue?vue&type=template&id=9c78f968&scoped=true&"
import script from "./SynchronizedPictureDiv.vue?vue&type=script&lang=js&"
export * from "./SynchronizedPictureDiv.vue?vue&type=script&lang=js&"
import style0 from "./SynchronizedPictureDiv.vue?vue&type=style&index=0&id=9c78f968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c78f968",
  null
  
)

export default component.exports